"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToasterStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
const ToasterStyled = (0, _styled.default)("div")`
    position: fixed;
    top: ${_designTokens.space.space50};
    left: 0;
    right: 0;

    z-index: ${_designTokens.layers.toast};
`;
exports.ToasterStyled = ToasterStyled;
//# sourceMappingURL=ToasterStyled.js.map